import React, { Component } from 'react';
import { 
    Grid, 
    Card,
    CardContent
} from '@mui/material';
import { isEmpty } from "lodash";
import { InputSelectNative, InputSelectMulti } from '../../common/Form';
import { MONTHS } from '../../../utils/generalFuncs';

class FilterSalaries extends Component {
    state = {  }
    render() {
        const { EMPLOYEES, SALARY_CATS } = this.props;
        let YEARS = []
        for (let year = 2019; year <= new Date().getFullYear(); year++) {
            YEARS.push(year)
        }
        return (
            <Card style={{margin: "10px"}}>
                <CardContent>
                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            <InputSelectMulti
                                label="Mois"
                                name="searchMonth"
                                onChange={(option) => this.props.handleSelect(option, "searchMonth")}
                                value={this.props.searchMonth}
                                id="searchMonth"
                                options={MONTHS.map( (month, index) => ({
                                    label: month,
                                    value: index,
                                    disabled: Array.isArray(this.props.searchMonth) && !!this.props.searchMonth.find(element => element.value === index)
                                    
                                })) }
                                isMulti
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <InputSelectNative
                                label="Année"
                                name="searchYear"
                                onChange={this.props.handleChange}
                                value={this.props.searchYear}
                                labelWidth={70} 
                                id="searchYear"
                                options={YEARS.map( year => (
                                    <option value={year} key={year}>
                                        {year}
                                    </option>
                                )) }
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <InputSelectNative
                                label="Statut Paiement"
                                onChange={this.props.handleChange}
                                value={this.props.pay_status}
                                labelWidth={120} 
                                name="pay_status" 
                                id="pay_status"
                                options={[
                                    <option value="WAITING" key="WAITING">Non Payés</option>,
                                    <option value="PAYED" key="PAYED" >Payés</option>
                                ]}
                            />
                        </Grid>
                        {!isEmpty(EMPLOYEES) && 
                            <Grid item xs={6}>
                                <InputSelectMulti
                                    label="Employé"
                                    id="searchEmployee"
                                    options={Object.values(EMPLOYEES).map( item => ({
                                        label: `${item.employee_matricule} - ${item.employee_lastname.toUpperCase()} ${item.employee_firstname}`,
                                        value: item.employee_id,
                                        disabled: Array.isArray(this.props.searchEmployee) && !!this.props.searchEmployee.find(element => element.value === item.employee_id)
                                        
                                    }))}
                                    value={this.props.searchEmployee}
                                    onChange={this.props.handleChangeEmployee}
                                    isMulti
                                />
                            </Grid>
                        }
                        {this.props.charges && !isEmpty(SALARY_CATS) && 
                            <Grid item xs={12}>
                                <InputSelectMulti
                                    label="Rubrique"
                                    id="searchCat"
                                    options={Object.values(SALARY_CATS).map( item => ({
                                        label: item.salary_cat_name,
                                        value: item.salary_cat_id,
                                        disabled: Array.isArray(this.props.searchCat) && !!this.props.searchCat.find(element => element.value === item.salary_cat_id)
                                    }))}
                                    value={this.props.searchCat}
                                    onChange={this.props.handleChangeCat}
                                    name="searchCat"
                                    isMulti
                                />
                                
                            </Grid>
                        }
                        
                        
                    </Grid>
                </CardContent>
            </Card>
        );
    }
}

export default FilterSalaries;